import React, { useState, useEffect } from 'react';

const Pagination = ({ data = [], itemsPerPage = 5, onPageChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Function to calculate paginated data
  const getPaginatedData = () => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return data.slice(start, end);
  };

  // Notify parent component about current page data
  useEffect(() => {
    if (onPageChange) {
      onPageChange(getPaginatedData());
    }
  }, [currentPage, data]);

  // Handlers for pagination buttons
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  // Function to display pagination numbers with ellipsis
  const renderPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= 6) {
      // Less than 6 pages: Show all page numbers
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // More than 6 pages
      // const leftPages = 2;
      // const rightPages = 2;
      // const middlePages = 3;

      if (currentPage <= 3) {
        // Show first pages and ... and the last page
        pageNumbers.push(1, 2, 3, '...', totalPages);
      } else if (currentPage > totalPages - 3) {
        // Show ... and last few pages
        pageNumbers.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
      } else {
        // Show pages around current page with ...
        pageNumbers.push(
          1,
          '...',
          currentPage - 1,
          currentPage,
          currentPage + 1,
          '...',
          totalPages
        );
      }
    }
    return pageNumbers;
  };

  return (
    <div className="flex items-center justify-center space-x-2 text-gray-700">
      {/* Left Arrow */}
      <button
        onClick={handlePreviousPage}
        className={`flex h-8 w-8 items-center justify-center ${currentPage === 1 ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-100'}`}
        disabled={currentPage === 1}
      >
        &lt;
      </button>

      {/* Page Numbers */}
      {renderPageNumbers().map((page, index) => (
        <button
          key={index}
          onClick={() => typeof page === 'number' && handlePageClick(page)}
          className={`flex h-8 w-8 items-center justify-center rounded ${currentPage === page ? 'bg-teal-400 text-white' : 'hover:bg-gray-100'}`}
          disabled={page === '...'}
        >
          {page}
        </button>
      ))}

      {/* Right Arrow */}
      <button
        onClick={handleNextPage}
        className={`flex h-8 w-8 items-center justify-center ${currentPage === totalPages ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-100'}`}
        disabled={currentPage === totalPages}
      >
        &gt;
      </button>
    </div>
  );
};

export default Pagination;
